import { createContext } from "react";
export const MonthlySalesContext = createContext(null);
